import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Home, Search, ArrowLeft, Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NotFoundPage = () => {
  const { i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-white flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-lg"
      >
        {/* Animated Compass */}
        <motion.div
          animate={{ rotate: [0, 10, -10, 0] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 1 }}
          className="inline-block mb-8"
        >
          <div className="w-32 h-32 bg-orange-100 rounded-full flex items-center justify-center">
            <Compass className="w-16 h-16 text-primary" />
          </div>
        </motion.div>

        {/* 404 Text */}
        <h1 className="text-8xl font-bold text-primary mb-4">404</h1>
        
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          {i18n.language === 'fr' 
            ? 'Page introuvable' 
            : 'Page not found'}
        </h2>
        
        <p className="text-gray-600 mb-8">
          {i18n.language === 'fr'
            ? 'Oups ! On dirait que vous vous êtes perdu en chemin. Cette page n\'existe pas ou a été déplacée.'
            : 'Oops! Looks like you got lost along the way. This page doesn\'t exist or has been moved.'}
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="gap-2">
            <Link to="/">
              <Home className="w-5 h-5" />
              {i18n.language === 'fr' ? 'Retour à l\'accueil' : 'Back to Home'}
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="gap-2">
            <Link to="/explore">
              <Search className="w-5 h-5" />
              {i18n.language === 'fr' ? 'Explorer les expériences' : 'Explore Experiences'}
            </Link>
          </Button>
        </div>

        {/* Back Link */}
        <button
          onClick={() => window.history.back()}
          className="mt-8 text-sm text-gray-500 hover:text-primary flex items-center gap-1 mx-auto"
        >
          <ArrowLeft className="w-4 h-4" />
          {i18n.language === 'fr' ? 'Retour à la page précédente' : 'Go back to previous page'}
        </button>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
